<template>
  <div class="login">
      <div class="loginTop">
        <div class="loginLogo warp">
          <div class="loginImgBox" @click="goToIndex">
            <img src="@/assets/images/dlogo.png" alt="">
          </div>
          <span>欢迎来到麦可思</span>
        </div>
      </div>
      <div class="loginCent">
        <div class="loginBox warp">
          <div class="leftImg">
            <img src="@/assets/images/banner.png" alt="">
          </div>
          <div class="loginForm">
            <div class="loginTit" v-text="isRegistered == '1' ? '注册' : '登录'"></div>
            <div class="loginFormBox">
              <div class="inputBox">
                <label>手机号码</label>
                <el-input v-model="userName" placeholder="请输入您的手机号码"></el-input>
              </div>
              <div class="inputBox">
                <label>验证码</label>
                <el-input v-model="verificationCode" placeholder="请输入验证码"></el-input>
                <span v-show="codeShow" class="codeBtn" @click="getCode">获取验证码</span>
                <span v-show="!codeShow" class="codeBtn codeCount">重新获取({{codeCountNum}}s)</span>
              </div>
              <div class="noLogin" :class="{registered: isRegistered === '1'}" >
                <el-checkbox v-show="isRegistered === '2'" v-model="isNoLogin">七天免登录</el-checkbox>
                <span @click="registered" v-text="isRegistered === '1' ? '登录' : '用户注册'"></span>
              </div>
              <div class="loginBtn" @click="login" v-text="isRegistered === '1' ? '注册' : '立即登录'">立即登录</div>
            </div>
            <div class="loginProtocol" v-if="isRegistered === '1'">
              <el-checkbox v-model="haveRead"></el-checkbox>
              <span>阅读并同意</span>
              <span @click="readAgreement">《麦可思服务协议》</span>
            </div>
          </div>
        </div>
      </div>
    <el-dialog
      title="麦可思商城用户注册协议"
      :visible.sync="dialogAgreement"
      width="50%">
尊敬的客户您好，欢迎您访问麦可思商城（以下简称：商城）。在您注册成为商城会员之前，请您务必认真阅读和理解《商城用户注册协议》（以下简称：协议）中所有的条款。您须完全同意协议中所有的条款，才可以注册成为本商城的会员，使用里面的服务。您在商城的注册和操作均将被视为是您对协议所有条款及内容的自愿接受。
<h3>一、声明</h3>
<h4>（一）商城内在线产品的所有权归长沙麦可思信息科技有限公司所有。</h4>
<h4>（二）您在商城进行注册时，一旦点击“我接受”按钮，即表示为您已自愿接受协议中所有的条款和内容。</h4>
<h4>（三）协议条款的效力范围仅限于本商城，您在商城的行为均受协议的约束。</h4>
<h4>（四）您使用商城服务的行为，即被视为您已知悉本商城的相关公告并同意。</h4>
<h4>（五）本商城有权在未提前通知您的情况下修改协议的条款。</h4>
<h4>（六）本商城有权在未提前通知您的情况下修改、暂停商城部分或全部的服务，且不承担由此产生来自您和第三方的任何责任。</h4>
<h4>（七）本商城提供免费注册服务，您的注册均是自愿行为，注册成功后，您可以得到商城更加完善的服务。</h4>
<h4>（八）您注册成为会员后账户和密码如有灭失，不会影响到您已办理成功业务的效力，本商城可恢复您的注册账户及相关信息但不承担除此以外的其它任何责任。</h4>
<h3>二、用户管理</h3>
<h4>（一）您在本商城的所有行为都须符合中国的法律法规，您不得利用本商城提供的服务制作、复制、发布、传播以下信息：</h4>
<h5>1、反对宪法基本原则的；</h5>
<h5>2、危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一的；</h5>
<h5>3、损害国家荣誉和利益的；</h5>
<h5>4、煽动民族仇恨、民族歧视、破坏民族团结的；</h5>
<h5>5、破坏国家宗教政策，宣扬邪教和封建迷信的；</h5>
<h5>6、散布谣言、扰乱社会秩序、破坏社会稳定的；</h5>
<h5>7、散布淫秽、色情、赌博、暴力、凶杀、恐怖内容或者教唆犯罪的；</h5>
<h5>8、侮辱或者诽谤他人，侵害他人合法权益的；</h5>
<h5>9、以及法律、法规禁止的其他内容。</h5>
 <h4>（二）您在本商城的行为，还必须符合其它国家和地区的法律规定以及国际法的有关规定。</h4>
  <h4>（三）不得利用本商城从事以下活动：</h4>
<h5>1、未经允许，进入他人计算机信息网络或者使用他人计算机信息网络的资源；</h5>
<h5>2、未经允许，对他人计算机信息网络的功能进行删除、修改或增加；</h5>
<h5>3、未经允许，对他人计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加；</h5>
<h5>4、制作、故意传播计算机病毒等破坏性程序的；</h5>
<h5>5、其他危害计算机信息网络安全的行为。</h5>
<h4>（四）遵守本商城其他规定和程序：</h4>
<h5>1、您对自己在本商城中的行为和操作承担全部责任；</h5>
<h5>2、您承担责任的形式包括但不仅限于，对受到侵害者进行赔偿、在本商城首先承担了因您的行为导致的行政处罚或侵权损害赔偿责任后，您应给予本商城的等额赔偿；</h5>
<h5>3、如果本商城发现您传输的信息含有本协议所规定的内容，本商城有权在不通知您的情况下采取包括但不仅限于向国家有关机关报告、保存有关记录、删除该内容及链接地址、关闭服务器、暂停您账号的操作权限、停止向您提供服务等措施。</h5>
<h3>三、注册会员权利和义务</h3>
<h4>（一）注册会员有权用本商城提供的服务功能。</h4>
<h4>（二）注册会员同意遵守包括但不仅限于《中华人民共和国保守国家秘密法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《互联网电子公告服务管理规定》、《互联网信息服务管理办法》等在内的法律、法规。</h4>
<h4>（三）您注册时有义务提供完整、真实、的个人信息，信息如有变更，应及时更新。</h4>
<h4>（四）您成为注册会员须妥善保管用户名和密码，用户登录后进行的一切活动均视为是您本人的行为和意愿，您负全部责任。</h4>
<h4>（五）您在使用本商城服务时，同意且接受本商城提供的各类信息服务。</h4>
<h4>（六）您使用本商城时，禁止有以下行为：</h4>
<h5>1、上载、张贴、发送电子邮件或以其他方式传送含有违反国家法律、法规的信息或资料，这些资料包括但不仅限于资讯、资料、文字、软件、音乐、照片、图形、等（下同）；</h5>
<h5>2、散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的资料；</h5>
<h5>3、冒充任何个人或机构，或以虚伪不实的方式误导他人以为其与任何人或任何机构有关；</h5>
<h5>4、通过本商城干扰、破坏或限制他人计算机软件、硬件或通讯设备功能的行为；</h5>
<h5>5、通过本商城跟踪或以其他方式骚扰他人。</h5>
<h3>四、用户隐私</h3>
我们承诺，对您个人的信息和隐私的安全承担保密义务。未经您授权或同意，本商城不会将您的个人资料信息泄露给第三方，但以下情况除外，且本商城不承担任何责任：
<h4>（一）政府单位按照中华人民共和国的法律、行政法规、部门规章、司法解释等规范性法律文件（统称“法律法规”），要求本商城提供的。</h4>
<h4>（二）由于您将用户和密码告知或泄露给他人，由此导致的个人资料泄露。</h4>
<h4>（三）包括但不仅限于黑客攻击、计算机病毒侵入或发作、政府管制等不可抗力而造成的用户个人资料泄露、丢失、被盗用或被篡改等。</h4>
<h4>（四）为免除他人正在遭受威胁到其生命、身体或财产等方面的危险，所采取的措施。</h4>
<h4>（五）本商城会与其他商城链接，但不对其他商城的隐私政策及内容负责。</h4>
<h4>（六）此外，您若发现有任何非法使用您的用户账号或安全漏洞的情况，应立即通告本商城。</h4>
<h4>（七）由于您自身的疏忽、大意等过错所导致的。</h4>
<h4>（八）您在本商城的有关记录有可能成为您违反法律法规和本协议的证据。</h4>
<h3>五、知识产权</h3>
本商城所有的域名、商号、商标、文字、视像及声音内容、图形及图像均受有关所有权和知识产权法律的保护，未经本商城事先以书面明确允许，任何个人或单位，均不得进行复制和使用。
<h3>六、法律适用</h3>
<h4>（一）协议由本商城的所有人负责修订，并通过本商城公布，您的注册行为即被视为您自愿接受协议的全部条款，受其约束。</h4>
<h4>（二）协议的生效、履行、解释及争议的解决均适用中华人民共和国法律。</h4>
<h4>（三）您使用商城提供的服务如产生争议，原则上双方协商解决，协商不成可向仲裁机构申请仲裁或人民法院提起诉讼。</h4>
<h4>（四）协议的条款如与法律相抵触，本商城可进行重新解析，而其他条款则保持对您产生法律效力和约束。</h4>
    </el-dialog>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import api from '../../api'
import { listSearchMixin } from '../../config/mixin'
import {mapMutations} from 'vuex'
export default {
  name: 'login',
  mixins: [listSearchMixin],
  data () {
    return {
      userName: '',
      verificationCode: '',
      isNoLogin: false,
      haveRead: false,
      codeShow: true,
      codeCountNum: '',
      dialogAgreement: false,
      isRegistered: '2'
    }
  },
  mounted () {
    if (this.$route.query.type) {
      this.isRegistered = this.$route.query.type
    }
  },
  methods: {
    ...mapMutations({
      setUserInfo: 'SET_USERINFO' // 修改用户信息
    }),
    getUserInfo () {
      let self = this
      let params = {
        url: api.getUser,
        method: 'GET'
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          self.setUserInfo(res.data)
          self.userInfoData = res.data
          // console.log(res)
        }
      })
    },
    getCode () {
      const TIME_COUNT = 120
      let self = this
      let reg = /^1[13456789]\d{9}$/
      if (!reg.test(self.userName)) {
        self.$message.error('手机号格式错误')
        return
      }
      let params = {
        url: api.vCode + `?phone=${self.userName}`,
        method: 'GET'
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          if (!this.timer) {
            this.codeCountNum = TIME_COUNT
            this.codeShow = false
            this.timer = setInterval(() => {
              if (this.codeCountNum > 0 && this.codeCountNum <= TIME_COUNT) {
                this.codeCountNum--
              } else {
                this.codeShow = true
                clearInterval(this.timer)
                this.timer = null
              }
            }, 1000)
          }
          this.$message.success('验证码获取成功')
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    // 阅读协议
    readAgreement () {
      this.dialogAgreement = true
    },
    goToIndex () {
      this.$router.push({path: '/'})
    },
    login () {
      let self = this
      let reg = /^1[13456789]\d{9}$/
      if (!reg.test(self.userName)) {
        self.$message({
          message: '手机号码格式错误'
        })
        return
      }
      if (self.verificationCode === '') {
        self.$message({
          message: '请输入验证码'
        })
        return
      }
      if (self.isRegistered === '2') {
        this.getLogin()
      } else if (this.haveRead) {
        this.getLogin()
      } else {
        this.$message.warning('请阅读并同意服务协议')
      }
    },
    getLogin () {
      let self = this
      let params = {
        url: api.login,
        method: 'POST',
        data: {
          phone: self.userName,
          verificationCode: self.verificationCode,
          type: self.isRegistered
        }
      }
      self.sendReq(params, (res) => {
        // console.log(res)
        if (res.code === '200') {
          if (self.isNoLogin) {
            Cookie.set('token', res.data.token, { expires: 7 })
          } else {
            Cookie.set('token', res.data.token, { expires: 1 })
          }
          this.getUserInfo()
          this.$message.success('登录成功')
          this.$router.push({path: '/'})
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    registered () {
      this.codeShow = true
      clearInterval(this.timer)
      this.timer = null
      this.userName = ''
      this.verificationCode = ''
      if (this.isRegistered === '1') {
        this.isRegistered = '2'
      } else {
        this.isRegistered = '1'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .login {
    height: 100vh;
    display: flex;
    flex-direction: column;
    min-height: 768px;
    .loginTop {
      box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
      position: relative;
      z-index: 999;
      flex-shrink: 0;
      .loginLogo {
        display: flex;
        align-items: center;
        height: 88px;
        img {
          width: 180px;
          margin-right: 30px;
        }
        span {
          font-size: 18px;
          color: $fontColor;
        }
        .loginImgBox {
          width: 180px;
          height: 40px;
          align-items: center;
          display: flex;
          margin-right: 20px;
          cursor: pointer;
          img {
            width: 100%;
          }
        }
      }
    }
    .loginCent {
      background: url('../../assets/images/beijing.png') no-repeat;
      flex-grow: 1;
      background-size: cover;
      display: flex;
      align-items: center;
      .loginBox {
        display: flex;
        align-items: center;
        position: relative;
      }
      .leftImg {
        width: 760px;
        height: 490px;
      }
      .loginForm {
        width: 540px;
        background: #ffffff;
        box-shadow: 0px 15px 14px 2px rgba(162, 87, 20, 0.15);
        border-radius: 20px;
        position: absolute;
        right: 0;
        .loginTit {
          height: 50px;
          display: flex;
          align-items: center;
          font-size: 30px;
          color: $mainColor;
          width: 100%;
          justify-content: center;
          margin: 70px 0;
          &:before {
            content: '';
            height: 2px;
            width: 98px;
            display: block;
            background: url("../../assets/images/dzuo.png") no-repeat;
            margin-right: 27px;
          }
          &:after {
            content: '';
            height: 2px;
            width: 98px;
            display: block;
            background: url("../../assets/images/dyou.png") no-repeat;
            margin-left: 27px;
          }
        }
        .loginFormBox {
          padding: 0 60px;
          .inputBox {
            position: relative;
            label {
              color: $fontColor;
              font-size: 18px;
              font-weight: 500;
            }
            >>> .el-input__inner {
              height: 64px;
              border: none;
              border-bottom: 1px solid #EEEEEE;
              font-size: 20px;
              color: #666666;
              padding-left: 0;
            }
            &:nth-child(2) {
              margin: 60px 0 20px 0;
            }
            .codeBtn {
              width: 140px;
              height: 54px;
              background: #EEEEEE;
              border-radius: 4px;
              display: block;
              line-height: 54px;
              text-align: center;
              position: absolute;
              right: 0;
              bottom: 10px;
              cursor: pointer;
            }
            .codeCount {
              color: #999999;
            }
          }
          .noLogin {
            color: #333333;
            font-size: 18px;
            margin:20px 0 60px 0;
            height: 30px;
            align-items: center;
            display: flex;
            justify-content: space-between;
            >>> .el-checkbox__label {
              font-size: 16px;
              color: #333333;
              font-weight: 400;
            }
            span {
              cursor: pointer;
              font-size: 16px;
              text-decoration: underline;
              color: #666666;
            }
          }
          .registered {
            justify-content: flex-end;
          }
          .loginBtn {
            width: 100%;
            background: $mainColor;
            height: 60px;
            line-height: 60px;
            border-radius: 27px;
            text-align: center;
            font-size: 20px;
            color: #ffffff;
            margin-bottom: 60px;
            cursor: pointer;
          }
        }
        .loginProtocol {
          padding: 0 60px;
          display: flex;
          align-items: center;
          height: 80px;
          line-height: 80px;
          border-top: 1px solid #EEEEEE;
          span {
            margin-left: 10px;
          }
          span:nth-child(3) {
            color: #426BEA;
            cursor: pointer;
          }
        }
        >>> .el-checkbox__inner {
          width: 20px;
          height: 20px;
          &:after {
            height: 10px;
            left: 7px;
            width: 4px;
          }
        }
      }
    }
    >>> .el-dialog__body {
      max-height: 500px;
      min-height: 300px;
      overflow: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue